import { Injectable } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { DecorationConfig } from './decoration.types';

@Injectable({ providedIn: 'root' })
export class DecorationService {
    private _config = new BehaviorSubject<DecorationConfig | null>(null);

    constructor(
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _route: ActivatedRoute,
        private _router: Router
    ) {}

    get config$(): Observable<DecorationConfig | null> {
        return this._config.asObservable();
    }

    get layout$(): Observable<'split' | 'full'> {
        return combineLatest([
            this._router.events,
            this._fuseMediaWatcherService.onMediaChange$,
        ]).pipe(
            map(([, { matchingAliases }]) => {
                const routesData = this._getAllRouteData(this._route);

                if (!matchingAliases.includes('lg')) {
                    return 'full';
                } else {
                    for (const data of routesData) {
                        if (data && 'decoration' in data) {
                            this.config = data['decoration'];
                            return 'split';
                        }
                    }
                    return 'full';
                }
            })
        );
    }

    set config(value: DecorationConfig | null) {
        this._config.next(value);
    }

    private _getAllRouteData(route: ActivatedRoute): Data[] {
        const data = route.snapshot.data;
        let allData: Data[] = [data];

        if (route.firstChild) {
            allData = allData.concat(this._getAllRouteData(route.firstChild));
        }

        return allData;
    }
}
